const state = {
  dashboardDialog: false
}

const mutations = {
  updateDashboardDialog (state, open) {
    state.dashboardDialog = open
  }
}

const actions = {
  getEmpty () {
    let obj = {
      url: '/api/typefile',
      query: '',
      method: 'get',
      noLoader: true
    }

    this.dispatch('request/doRequest', obj).then(response => {
      response.data.map(type => {
        type.disab = true
        return type
      })

      this.docTypes = response.data
      let obj = { docTypes: response.data }

      this.commit('documents/updateDocsList', obj)
    })
  }
}

export default {
  namespaced: true,
  root: true,
  mutations,
  actions,
  state
}
